export enum Reasons {
  Reconstruction = 'klient si navrhl rekonstrukci, potřebuje pomoct s dalšími kroky, výběrem partnera na rekonstrukci a výběrem financování',
  CallBack = 'Klient nedokončil návrh rekonstrukce v Rekalkule a chce pomoct s dalšími kroky.',
  Financing = 'Klient chce domluvit schůzku, kde získá informace k financování, dotacím i doporučeným partnerům pro rekonstrukci.',
  Grant = 'klient chce pomoct s výběrem dotace, výběrem partnera na rekonstrukci a výběrem financování',
  HowToApply = 'klient chce pomoct s podáním dotace, založením bankovní identity, výběrem partnera na rekonstrukci a výběrem financováním',
}
